<core-generic-table
    [dataInput]="quotes()"
    [endpoint]="endpoint()"
    [listTitle]="'quotes.title' | translate"
    [columns]="columns"
    [modalTabs]="modalFields()"
    [actions]="actions"
    [globalActions]="globalActions"
    [dataInput]="quotesData()"
    [modelFactory]="quotesModelFactory"
    [showFilter]="true"
    [showSelection]="false"
    [showActions]="true"
    [showCreateButton]="true"
    [customArrayKey]="'quotes'"
    [enablePagination]="true">
</core-generic-table>